import api from "../services/api";
import { $Q } from "../utils/query-selector";
import { stringToHTML } from "../utils/to-html";
import { swiperCollectionSection } from "./carousel-collection";
import { btnAddToCart } from "./cart";
import { openCloseModal, renderElements } from "./product-modal";

/**
 * Render recommendation by API with product ID
 * @return void
 */
async function getRecommendation() {
  const {
    dataset: { product },
  } = $Q("#product-recommendations");

  const html = await api.recommendationByApi(product, "product-recommendation");
  const recommendation = $Q("#render-recommendation-js", stringToHTML(html));

  if (recommendation && recommendation.innerHTML.trim().length) {
    const container = $Q("#re-render-recommendation-js");
    container.innerHTML = recommendation.outerHTML;
    swiperCollectionSection();
    renderElements();
    openCloseModal(true);
    btnAddToCart(".add-cart-js", container);
  }
}

/**
 * Create intersection observer from product page
 * and observe recommendation section
 * @return void
 */
// (function initUpsell() {
//   const section = $Q("#product-recommendations");

//   const handle = (entries, observer) => {
//     if (!entries[0].isIntersecting) return;
//     observer.unobserve(section);
//     getRecommendation();
//   };

//   const observer = new IntersectionObserver(handle, {
//     rootMargin: "0px 0px 200px 0px",
//   });

//   section && observer.observe(section);
// }());
getRecommendation();
